export enum ActiveView {
    DefaultView = 'Login',
    CustomerSelection = 'CustomerSelection'
}
